import React, { useState, useEffect } from 'react';
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import { useFormikContext } from 'formik';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';
import _ from 'lodash';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import {
  rotatge_45_clock,
  valuationDocBox,
  editIcon
} from './Valuation.module.css';
const EditIcon = '/images/icons/CmDashIcons/editIcon.svg';
import { getValuationDetails } from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import { numberFormat } from '../../../../common/constants/NumberFormat';
import PopUp from '../../../../common/components/PopUp/PopUp';
import ShowDoc from '../../../../containers/CMDashboard/ShowDoc';

const ValuationLists = ({ parentController }) => {
  const [valuationList, setValuationList] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [dontClose, setDontClose] = useState(true);

  useEffect(() => {
    setType('loading');
    setText('Loading...');
    setShow(true);
    setDontClose(true);
    getValuationDetails(getApplicantionInfo().leadId)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        if (Array.isArray(res)) {
          setValuationList(res);
        } else {
          setValuationList([]);
        }
      })
      .catch(error => {});
  }, []);

  const addMoreIconStyle = {
    color: `${valuationList.length >= 2 ? '#C4C4C4' : '#FF8000'}`,
    fontSize: '18px',
    marginLeft: '3px',
    marginRight: '3px',
    fontWeight: 300
  };
  const AddNewvaluation = () => (
    <div
      className="float-right mt-8 ml-auto"
      onClick={() => {
        if (valuationList.length == 2 || valuationList.length > 2) return;
        parentController?.setStep('addValuation');
        parentController.setCurrValuation(valuationList.length + 1);
        parentController.setResponseContainer([]);
      }}
    >
      <button
        type="button"
        className={`rounded bg-orange-650 font-roboto font-normal md:bg-white  bg-opacity-50 text-center px-4 py-2 flex  md:text-sm xxl:text-base items-center ${
          valuationList.length >= 2
            ? 'text-grey-500 cursor-not-allowed'
            : 'text-orange-600 cursor-pointer'
        }`}
      >
        <ControlPointOutlinedIcon style={addMoreIconStyle} />
        Add More
      </button>
    </div>
  );

  return (
    <div className="w-12/12 mr-auto md:px-6 px-2 my-1 bg-blue-1210 md:bg-white">
      <div className="w-full block md:mt-16">
        <div className="font-roboto font-medium text-sm text-black-850 mr-auto w-full md:block hidden">
          Valuation Details
        </div>
        <div className="md:hidden block xxl:w-3/12 xl:w-2/12 md:w-1/12 ">
          <AddNewvaluation />
        </div>

        <div className="w-full flex">
          <div className="xxl:w-9/12 xl:w-10/12 md:w-11/12 w-full">
            <div className="w-full my-5 block ">
              {valuationList.map((each, index) => (
                <ValuationList
                  eachData={each}
                  key={index}
                  indexInt={index}
                  parentController={parentController}
                  index={index}
                />
              ))}
            </div>
            <div className="w-full">
              {valuationList.length == 0 ? (
                <div className="font-roboto font-normal text-base text-black-500 text-left mt-10 mb-7">
                  No Data found! Please Add Valuation Details.
                </div>
              ) : null}
            </div>
          </div>
          <div className="md:block hidden ml-auto float-right">
            <AddNewvaluation />
          </div>
        </div>
      </div>
      <PopUp
        type={type}
        text={text}
        setShow={setShow}
        show={show}
        dontClose={dontClose}
      />
    </div>
  );
};

const ValuationList = ({ eachData, parentController, indexInt }) => {
  const [filesAttached, setFilesAttached] = useState([]);
  const data = eachData?.valuationDetails;
  const [planCopyDocLink, setplanCopyDocLink] = useState('');
  const [saleAgreementDocLink, setSaleAgreementDocLink] = useState('');
  const [valuationReportDocLink, setValuationReportDocLink] = useState('');

  useEffect(() => {
    const files = [];
    if (eachData?.planCopyDocLink) {
      files.push('Plan Copy'), setplanCopyDocLink(eachData?.planCopyDocLink);
    }
    if (eachData?.saleAgreementDocLink) {
      files.push('Sales Agreement'),
        setSaleAgreementDocLink(eachData?.saleAgreementDocLink);
    }
    if (eachData?.valuationReportDocLink) {
      files.push('Valuation Report'),
        setValuationReportDocLink(eachData?.valuationReportDocLink);
    }
    setFilesAttached(files);
  }, []);
  const dataSkeleton = [
    {
      label: 'Name of the  agency',
      seachValue: 'agencyName'
    },
    {
      label: 'Person Name',
      seachValue: 'personName'
    },
    {
      label: 'Contact No.',
      seachValue: 'contactNumber'
    },
    {
      label: 'Eamil Id',
      seachValue: 'emailId'
    },
    {
      label: 'Date Submitted',
      seachValue: 'submittedDate'
    }
  ];
  const valuationDocs = [
    {
      lable: 'Sales Agreement',
      attach: true
    },
    {
      lable: 'Plan Copy',
      attach: true
    }
  ];
  const valuationReport = {
    lable: 'Valuation Report',
    attach: true
  };

  const VauationListOverView = ({ each, index }) => (
    <div
      className="lg:w-4/12  w-full my-1 md:my-3 xl:float-left xl:flex-no-wrap px-1 xl:block flex flex-wrap "
      key={index}
    >
      <div className="flex flex-wrap w-full">
        <div className={`md:block w-full flex my-1 `}>
          <p
            className={`font-roboto font-nomal text-sm text-grey-1003 text-left w-full`}
          >
            {each.label}
          </p>
          <p
            className={`font-roboto font-medium text-sm  text-black-400 text-left  w-full break-words`}
          >
            <span className="md:hidden mx-1">:</span>{' '}
            {_.get(data, `${each.seachValue}`, false)
              ? _.get(data, `${each.seachValue}`, '---')
              : '---'}
          </p>
        </div>
      </div>
    </div>
  );
  const ValuationDocListOverView = ({ each, index }) => {
    const [fullImage, setFullImage] = useState(false);

    let url = '';
    if (each.lable == 'Sales Agreement') url = saleAgreementDocLink.url;
    else if (each.lable == 'Plan Copy') url = planCopyDocLink.url;
    else if (each.lable == 'Valuation Report') url = valuationReportDocLink.url;
    return (
      <div className={`w-4/12 pr-3  float-left mr-4  ${valuationDocBox}`}>
        <div
          className=" bg-green-dim rounded  flex  items-center py-2 my-1 px-1 cursor-pointer"
          key={index}
          onClick={() => setFullImage(true)}
        >
          <div className={`${rotatge_45_clock} mr-1 items-center`}>
            <AttachFileIcon
              style={{
                color: '#16BF00',
                height: '17px',
                width: '17px'
              }}
            />
          </div>
          <div className="w-full items-center">
            <p className="font-roboto font-normal text-xs  text-green-flagGreen ">
              {each.lable}
            </p>
          </div>
        </div>
        <ShowDoc
          file={url}
          show={fullImage}
          setShow={setFullImage}
          autoCheck={true}
        />
      </div>
    );
  };

  const handleUpdateView = () => {
    parentController?.setCurrValuation(indexInt + 1);
    parentController?.setStep('addValuation');
    parentController.setResponseContainer(eachData);
  };
  return (
    <div className="md:px-3 flex w-12/12 ">
      <div
        className={` bg-orange-200  my-3 pl-1 w-full md:-ml-3 border border-grey-1002 rounded `}
      >
        <div
          className={`float-right ml-auto mr-2 md:-mt-4 md:shadow md:-mr-4  cursor-pointer ${editIcon}`}
          onClick={handleUpdateView}
        >
          <div className="items-center">
            <img src={EditIcon} className="w-4 ml-3 mt-2" />
          </div>
        </div>

        <div className="w-full md:bg-navy-700 bg-white px-3 py-5 h-full rounded">
          {dataSkeleton.map((each, index) => (
            <VauationListOverView each={each} index={index} />
          ))}
          <div className="w-full  float-left block ">
            {valuationDocs.map((each, index) => {
              if (!filesAttached.includes(each.lable)) return;
              return <ValuationDocListOverView each={each} index={index} />;
            })}
          </div>
          {filesAttached.includes('Valuation Report') ? (
            <React.Fragment>
              <div className="w-full float-left my-3">
                <hr
                  className="border-dashed border"
                  style={{ borderColor: '#2a9aa540' }}
                />
              </div>
              <div className="">
                <ValuationDocListOverView each={valuationReport} index={2} />
                <div className="float-right ml-auto block items-center">
                  <p className="font-roboto font-normal text-sm text-grey-1003 text-left ">
                    Valuation amount
                  </p>
                  <p className="font-roboto font-medium text-base text-black-400 text-left ">
                    &#8377; {numberFormat(data.valuationAmount)}
                  </p>
                </div>
              </div>
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default withErrorHandler(ValuationLists);
